import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { Button, Checkbox, CircularProgress, Modal, Box, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import mainPath from '../utils/path';

const useStyles = makeStyles((theme)=>({
    cartListBox: props => ({
      maxWidth: props.maxWidth,
      margin:'0 auto',
      display: 'flex',
      flexDirection: 'column',
      padding:'270px 10px 0 10px',

      fontFamily:[
        'Noto Sans KR'
      ],
      [theme.breakpoints.down(1025)]: {
        padding:'150px 10px 0 10px',
      },

    }),
    cartListBoxH1:{
      fontSize:'38px',
      textAlign:'center',
      letterSpacing: '-1.9px',
      paddingBottom:'60px',
      fontFamily:[
        'Noto Sans KR'
      ],
    },
    mobileTitlesItem:{
      display:'none',
      fontWeight:'400',
      [theme.breakpoints.down(1025)]: {
        display: 'flex',
        alignItems: 'center',
      }
    },
    cartTitle: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 400,
      paddingTop: 5,
      paddingBottom: 5,
      borderTop: '2px solid #007235',
      borderBottom: '2px solid #007235',
      fontFamily:[
        'Noto Sans KR'
      ],
      [theme.breakpoints.down(1025)]: {
        borderBottom: 'none',
      }
    },
    TitlesItem: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 400,
      fontFamily:[
        'Noto Sans KR'
      ],

      [theme.breakpoints.down(1025)]: {
        display:'none'
      }
    },
    cartItemBox:{
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
    },

    noItmebox: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 100,
      borderBottom: '1px solid gray',
    },
    modalBox: {
        width: 400,
        height: 200,
        backgroundColor: '#fff',
        borderRadius: 10,
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
    },
    modal: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',       
        position:'relative',
    },
    countBtn:{
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      position:'absolute',
      top:'50%',
      left:'50%',
      transform:'translate(-50%, -50%)'

    },
    countBtnH1:{
      padding:'0 10px',
      fontFamily:[
        'Noto Sans KR'
      ],
    },
    lastBtn:{
      display:'flex',
      justifyContent:'center',
      padding:'20px 0',
      position:'absolute',
      top:'57%',
      left:'50%',
      transform:'translate(-50%, -50%)'
    },
    topBtn:{
      margin:'20px 0',
      display:'flex'
    },
    totalDiv:{
      margin:'50px 0 ',
      borderTop:'2px solid #007235',
      borderBottom:'2px solid #CCCCCC',
      padding:'15px 0',
      [theme.breakpoints.down(1025)]: {
        borderBottom:'none'
      }
    },
    tableThDiv:{
      display:'flex',
      justifyContent:'space-around',
      borderBottom:'2px solid #CCCCCC',
      [theme.breakpoints.down(1025)]: {
        flexDirection:'column',
      }
    },
    tableTh:{
      padding:'0 0 15px 0',
    },
    tableThtotal:{
      padding:'0 0 15px 0',
      [theme.breakpoints.down(1025)]: {
        fontWeight:'700',
        fontSize:'18px',
      },

    },
    tableData:{
      height:'100px',
      display:'flex',
      justifyContent:'space-around',
      alignItems:'center',
      [theme.breakpoints.down(1025)]: {
        display:'none',
      }
    },
    mobileBox:{
      [theme.breakpoints.down(1025)]: {
        display:'flex',
        justifyContent:'space-around',
        borderBottom:'2px solid #CCCCCC',
        padding:'10px 0 0 0',
        '&:first-child':{
          padding:'0'
        },
        '&:last-child':{
          borderBottom:'none',
        }
      }
    },
    mobileData:{
      display:'none',
      [theme.breakpoints.down(1025)]: {
        display:'block',
      }
    },
    mobileDataTotal:{
      display:'none',
      [theme.breakpoints.down(1025)]: {
        display:'block',
        fontWeight:'700',
        fontSize:'18px',
      }
    },
    topBtnLeft:{
      margin:'0 15px 0 0'
    },
    bottomBtn:{
      display:'flex',
      padding:'20px 0',
      justifyContent:'center',
      
      [theme.breakpoints.down(1025)]: {
        flexDirection:'column',
        display:'none',
      }
    },
    bottomMiddleBtn:{
      margin:'0 15px'
    },
    bottomLastBtn:{
      
    },
    mobileBottomBtn:{
      display:'none',
      [theme.breakpoints.down(1025)]: {
        display:'flex',
        justifyContent:'center',
        
      }
    },



  }));
  
  
  
  const CartListType1 = ({data, setData, getCartItems, maxWidth = 1200, deliveryPrice = 14000}) => {
    const theme = useTheme();
    let editTheme = {...theme, maxWidth}
    let navigate = useNavigate();
    const classes = useStyles(editTheme);
    const sendCost = parseInt(useSelector(state => state.config.shopDefaultConfig.de_send_cost_list));
    const [checks, setChecks] = useState([])
    const [allChecked, setAllChecked] = useState(false)
    const [loading, setLoading] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)

    const [editQty, setEditQty] = useState(0)
    const [edtStockQty, setEdtStockQty] = useState(0)
    const [editId, setEditId] = useState('')

    const [dialog, setDialog] = useState('');

  
    useEffect(() => {
      // 전체선택 관련 로직
      let allCheckList = []
  
      if(allChecked) {
        data.forEach(item => allCheckList.push(item['ct_id']));
        setChecks(allCheckList)
      } else {
        setChecks(allCheckList)
      }
      
    }, [allChecked])

  
    
    const noItem = () => (<div className={classes.noItmebox}>
      <p>현재 카트에 상품이 없습니다</p>
    </div>)
  
    const lodingBox = () => (<div className={classes.noItmebox}>
      <CircularProgress />
    </div>)
  
  
    const selectDelete = async() => {
  
      if (checks.length === 0) return setDialog('취소할 상품을 선택해 주세요!')
  
      try {
        setLoading(true)
        const resDel = await axios.post('/api/shop/deleteSelectCart/', {selChecks: checks})
  
        if(!resDel.data.success) {
          setLoading(false)
          return
        }
  
        getCartItems()
        setChecks([])      
        setLoading(false)
    
      } catch (e) {
        console.log(e)
      }
      
    }

    const onEditQty = async() => {
  
      try {
        const resEdit = await axios.post('/api/shop/editSelectCart/', {ct_id: editId, ct_qty: editQty})
  
        if(!resEdit.data.success) return setDialog('수량변경 실패')
        
        handleClose()

        getCartItems()
    
      } catch (e) {
        console.log(e)
      }
      
    }
  
    const allDelete = async() => {
      let allCheckList = []

      data.forEach(item => allCheckList.push(item['ct_id']));

      try {
        setLoading(true)
        const resDel = await axios.post('/api/shop/deleteSelectCart/', {selChecks: allCheckList})
  
        if(!resDel.data.success) {
          setLoading(false)
          return
        }
  
        setChecks([])       
        setLoading(false)
        getCartItems()
    
      } catch (e) {
        console.log(e)
      }
    }
  
    const selectOrder = () => {
      let today = new Date();   
      let hours = today.getHours()

      // if (hours < 10 || hours > 21) {
      //   setDialog('주문가능 시간은 10~22시 사이 입니다.')
      //   return
      // }

      if(checks.length === 0) {
        setDialog('상품을 선택해 주세요')
        return
      }

      let soldoutList = []
      data.forEach((item) => {
        checks.forEach((chkItem) => {
          if(item['ct_id'] === chkItem && item['it_stock_qty'] === 0){
            soldoutList.push(item['it_name'])
          }
        })
      })

      if (soldoutList.length > 0 ) {
        setDialog(`품절상품이 포함되어 있습니다.   품절 상품을 삭제 해주세요.   (${soldoutList.reduce((res, itm) => res + ' ' + itm + ',', '')})`)
        return  
      }


      let noUseList = []
      data.forEach((item) => {
        checks.forEach((chkItem) => {
          if(item['ct_id'] === chkItem && item['it_use'] === 0){
            noUseList.push(item['it_name'])
          }
        })
      })
      if (noUseList.length > 0 ) {
        setDialog(`판매하지 않는 상품이 포함되어 있습니다. 해당 상품을 삭제 해주세요.   (${noUseList.reduce((res, itm) => res + ' ' + itm + ',', '')})`)
        return  
      }


      navigate("/Order", {
        state: { ctList: checks }
      });
    }
  

    const allOrder = () => {
      let today = new Date();   
      let hours = today.getHours()

      if (data.length === 0) return setDialog('카트에 상품이 없습니다.')
      let soldoutList = []
      let allList = []

      // if (hours < 10 || hours > 21) {
      //   setDialog('주문가능 시간은 10~22시 사이 입니다.')
      //   return
      // }

      data.forEach((item) => {
        if(item['it_stock_qty'] === 0){
          soldoutList.push(item['it_name'])
        }
      })

      if (soldoutList.length > 0 ) {
        setDialog(`품절상품이 포함되어 있습니다.   품절 상품을 삭제 해주세요.   (${soldoutList.reduce((res, itm) => res + ' ' + itm+',', '')})`)
        return  
      }

      let noUseList = []
      data.forEach((item) => {
        checks.forEach((chkItem) => {
          if(item['ct_id'] === chkItem && item['it_use'] === 0){
            noUseList.push(item['it_name'])
          }
        })
      })
      if (noUseList.length > 0 ) {
        setDialog(`판매하지 않는 상품이 포함되어 있습니다. 해당 상품을 삭제 해주세요.   (${noUseList.reduce((res, itm) => res + ' ' + itm + ',', '')})`)
        return  
      }

      data.forEach((item) => {
        allList.push(item['ct_id'])
      })


      navigate("/Order", {
        state: { ctList: allList }
      });

    }


    const handleOpen = (qty, id, itStockQty) => {
        setEdtStockQty(itStockQty)
        setEditQty(qty)
        setEditId(id)
        setModalOpen(true)
    }

    const handleClose = () => {
        setModalOpen(false)
    }
  
  
    return(
      <div className={classes.cartListBox}>
        <h1 className={classes.cartListBoxH1}>장바구니</h1>
        <h1 className={classes.mobileTitlesItem} style={{flex: 0.1}}>
            <Checkbox 
              checked={allChecked}
              onChange={e => setAllChecked(e.target.checked)}
              style ={{
                color: "#007235",
              }}
            />
            전체선택
        </h1>
        <div className={classes.cartTitle}>
          <h1 className={classes.TitlesItem} style={{flex: 0.1}}>
            <Checkbox 
              checked={allChecked}
              onChange={e => setAllChecked(e.target.checked)}
              style ={{
                color: "#007235",
              }}
            />
          </h1>
          <h1 className={classes.TitlesItem} style={{flex: 1}}>상품정보</h1>
          <h1 className={classes.TitlesItem} style={{flex: 0.5}}>수량</h1>
          <h1 className={classes.TitlesItem} style={{flex: 0.5}}>판매가</h1>
          <h1 className={classes.TitlesItem} style={{flex: 0.5}}>배송비</h1>
        </div>
        <div className={classes.cartItemBox}>
          {data.length === 0 ? 
              noItem() : 
              data.map((item) => 
                <CartItem
                  key={item['ct_id']} 
                  ctId={item['ct_id']} 
                  odId={item['od_id']} 
                  itId={item['it_id']} 
                  itName={item['it_name']} 
                  ctPrice={item['ct_price']} 
                  ctQty={item['ct_qty']} 
                  itImg1={item['it_img1']} 
                  itStockQty={item['it_stock_qty']}
                  checks={checks}
                  setChecks={setChecks}
                  handleOpen={handleOpen}
                  itSoldout={item['it_soldout']}
                />)
          }
        </div>
        <div className={classes.topBtn}>
          {loading ? lodingBox() : (
          <>
            <div className={classes.topBtnLeft}>
                <Button 
                  variant="outlined" 
                  onClick={selectDelete}
                  style ={{
                    color: "#ffff", 
                    background:'#007235', 
                    border:'none',
                    fontFamily:[
                      'Noto Sans KR'
                    ],
                  }}
                >
                  선택삭제
                </Button>
            </div>
            <div>
              <Button 
                variant="outlined" 
                onClick={allDelete}
                style ={{
                  color: "#007235", 
                  background:'#fff', 
                  border:'1px solid #007235',
                  fontFamily:[
                    'Noto Sans KR'
                  ],
                }}
              >
                비우기
              </Button>
            </div>
          </>
          )}

        </div>
        <div className={classes.totalDiv}>
          <div>
            <div className={classes.tableThDiv}>
              <div className={classes.mobileBox}>
                <div className={classes.tableTh}>총 상품가격</div>
                <div className={classes.mobileData}>
                  {data.length > 0 ?
                    data.reduce((result, item) => result + (item['ct_price'] * item['ct_qty']), 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') :
                  0} 원
                </div>
              </div>
              <div className={classes.mobileBox}>
                <div className={classes.tableTh}>총 배송비</div>
                <div className={classes.mobileData}>
                  {sendCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원 
                </div>
              </div>
              <div className={classes.mobileBox}>
                <div className={classes.tableThtotal}>총 결제금액</div>
                <div className={classes.mobileDataTotal}>
                  {data.length > 0 ? 
                    (data.reduce((result, item) => result + (item['ct_price'] * item['ct_qty']), 0) + sendCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') :
                  0} 원
                </div>
              </div>
            </div>
            <div className={classes.tableData}>
              <div>
                {data.length > 0 ?
                  data.reduce((result, item) => result + (item['ct_price'] * item['ct_qty']), 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') :
                0} 원
              </div>
              <div>
                {sendCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원 
              </div>
              <div>
                {data.length > 0 ? 
                  (data.reduce((result, item) => result + (item['ct_price'] * item['ct_qty']), 0) + sendCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') :
                0} 원
              </div>
            </div>
          </div>
        </div>
        <div className={classes.bottomBtn}>
          <Button 
            variant="outlined" 
            onClick={selectOrder} 
            style ={{
                color: "#ffff", 
                background:'#007235', 
                border:'none',
                fontFamily:[
                  'Noto Sans KR'
                ],
              }}>
                선택상품주문
          </Button>
          <div className={classes.bottomMiddleBtn}>
            <Button 
              variant="outlined" 
              onClick={allOrder}
              style ={{
                color: "#007235", 
                background:'#fff', 
                border:'1px solid #007235',
                fontFamily:[
                  'Noto Sans KR'
                ],
              }}  
            >
              전체상품주문
            </Button>
          </div>
         <div className={classes.bottomLastBtn}>
            <Button 
              variant="outlined" 
              style ={{
                color: "#ffff", 
                background:'#007235', 
                border:'none',
                fontFamily:[
                  'Noto Sans KR'
                ],
              }}
              onClick={() => navigate("/ShopMain/ShopSearch", {state: { keyword: '' }})}
            >
              쇼핑계속
            </Button>
          </div>
        </div>
        <div className={classes.mobileBottomBtn}>
          <Button 
            variant="outlined" 
            onClick={selectOrder} 
            style ={{
                color: "#ffff", 
                background:'#007235', 
                border:'none',
                width:'100%',
                height:'50px',
                fontSize:'18px',
                fontWeight:'400',
                fontFamily:[
                  'Noto Sans KR'
                ],
              }}>
                결제하기
          </Button>
        </div>

        <Modal
            open={modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={classes.modal}
        >
            <Box className={classes.modalBox}>    
                {edtStockQty !== 0 ? (
                    <>
                      <div className={classes.countBtn}>
                    
                      <Button 
                        variant="outlined" 
                        size="small"
                        onClick={() => setEditQty(editQty-1 < 1 ? 1 : editQty-1)}
                        style ={{
                          color: "#007235", 
                          background:'#fff', 
                          border:'1px solid #007235',
                          fontFamily:[
                            'Noto Sans KR'
                          ],
                        }} 
                      >
                        -
                      </Button>
                      <h1
                        className={classes.countBtnH1}
                      >
                        {editQty}
                      </h1>
                      <Button 
                        variant="outlined" 
                        size="small"
                        onClick={() => {
                          console.log(edtStockQty)
                          if (editQty + 1 >= edtStockQty) return setEditQty(edtStockQty);
                          setEditQty(editQty+1)
                        }}
                        style ={{
                          color: "#007235", 
                          background:'#fff', 
                          border:'1px solid #007235',
                          fontFamily:[
                            'Noto Sans KR'
                          ],
                        }} 
                      >
                        +
                      </Button>
                    </div>
  
                    <div className={classes.lastBtn}>
                      <Button 
                        variant="outlined" 
                        size="small"
                        onClick={() => onEditQty()}
                        style ={{
                          color: "#007235", 
                          background:'#fff', 
                          border:'1px solid #007235',
                          fontFamily:[
                            'Noto Sans KR'
                          ],
                        }} 
                      >
                        수량변경하기
                      </Button>
                    </div>
                  </>
                ) : (
                <div
                  style={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}
                >
                  <h3>현재 재고가 0개 인 상품입니다. </h3>
                  <h3>본 상품을 카트에서 삭제하십시오. </h3>   
                  <Button onClick={handleClose} >
                    확인
                  </Button>
                </div>
                )}            
                  

            </Box>
        </Modal>

        <Dialog
            open={dialog === '' ? false : true}
            onClose={() => setDialog('')}
        >
            <DialogTitle id="alert-dialog-title">
                {dialog}
            </DialogTitle>
            <DialogActions>
                <Button onClick={() => setDialog('')} autoFocus>
                    확인
                </Button>
            </DialogActions>
        </Dialog>

      </div>
    )
  }
  
  
  
  
  const useStylesCartItem = makeStyles((theme)=>({
    ItemBox: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderBottom: '1px solid #CCCCCC',
      paddingTop: 5,
      paddingBottom: 5,
    },
    cartItemDiv:{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      flex:1,
      [theme.breakpoints.down(1025)]: {
        flexDirection:'column',
        flex:0.3,
        display:'none',
      }
    },
    cartItem: {
      fontWeight: 400,
    },
    subjectBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      flex: '0.6 1 0%',

      [theme.breakpoints.down(1025)]: {
        flex: 1
      }
    },
    subjectImg: {
      width: 150,
      height: 150,
      marginRight: 10,

      [theme.breakpoints.down(1025)]: {
        width: 100,
        height: 100,
        marginRight: 5,
      }
    },
    subjectCont: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.down(1025)]: {
        fontSize:'12px',
      }
    },
    ItemEdit:{
      margin:'10px 0'
    },
    mobileCartItemDiv:{
      display:'none',
      [theme.breakpoints.down(1025)]: {
        display:'block',
      }
    },
    mobileCartItemprice:{
      fontSize:'15px',
      fontWeight:'500'
    },
    mobileCartItem:{
      fontSize:'18px',
    },
    mobileQty:{
      display:'none',
      fontSize: 14,
      [theme.breakpoints.down(1025)]: {
        display:'block',
      }
    },

  
  }));
  
  const CartItem = ({ctId, odId, itId, itName, ctPrice, ctQty, itImg1, itStockQty, checks, setChecks, handleOpen, itSoldout}) => {
    const theme = useTheme();
    const classes = useStylesCartItem(theme);
  
  
  
    return (
      <div className={classes.ItemBox}>
          <h1 className={classes.cartItem} style={{flex: 0.2}}>
            <Checkbox
              checked={checks.includes(ctId)}
              onChange={() => !checks.includes(ctId) ?
                            setChecks([...checks, ctId]) : 
                            setChecks([...checks.filter((item) => item !==  ctId)])
                        }
              style ={{
                color: "#007235",
              }}
              className={classes.checkbox}
            />
          </h1>
          <div 
            className={classes.subjectBox} 
          >
            <img  
              src={`${mainPath}/media/data/item/${itImg1}`} 
              className={classes.subjectImg}
            />
            <div className={classes.subjectCont}>
              <h1 className={classes.subjectContMain}>{itName}</h1>
              <div className={classes.ItemEdit}>
                <Button 
                  variant="outlined" 
                  size="small"
                  onClick={() => handleOpen(ctQty, ctId, itStockQty)}
                  style ={{
                    color: "#007235", 
                    background:'#fff', 
                    border:'1px solid #007235',
                    fontFamily:[
                      'Noto Sans KR'
                    ],
                  }} 
                >
                  수량변경
                </Button>
              </div>
              <b className={classes.mobileQty}>수량: {ctQty}</b>
              <div className={classes.mobileCartItemDiv}>
                <h1 className={classes.mobileCartItemprice}>판매가 </h1>
                <h1 className={classes.mobileCartItem} >
                  {itSoldout === 1 ? '품절' : ctPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
                </h1>
              </div>
            </div>
            
          </div>         
          <div className={classes.cartItemDiv}>
            <h1 className={classes.cartItem} >{ctQty}</h1>
            <h1 className={classes.cartItem} >{itSoldout === 1 ? '품절' : ctPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</h1>
            <h1 className={classes.cartItem} >선불</h1>
          </div>
      </div>
  
    )
  }
  
  
  export default CartListType1
  